import React from 'react';
import axios from 'axios';
import math from 'mathjs';
import numbro from 'numbro';
import { message } from 'antd';
import Country from 'country-data';
import WAValidator from 'multicoin-address-validator';
import bchaddr from 'bchaddrjs';
import _toLower from 'lodash/toLower';

import {
	MONTH_NAMES,
	// NETWORK
} from '../config/constants';

export const DONUT_PERCENTAGE_FORMAT = '0.[0]%';
const urlRegex = /^(https|http)/;
const replaceURLRegex = /(^\w+:|^)\/\//;

export const hasErrors = (fieldsError) => {
	return Object.keys(fieldsError).some((field) => fieldsError[field]);
};

export const returnDate = (data) => {
	if (!data) return null;
	const d = new Date(data);
	const year = d.getFullYear();
	const month = d.getMonth();
	const date = d.getDate();

	return `${MONTH_NAMES[month]} ${date}, ${year}`;
};

export const timeStamp = (data) => {
	if (!data) return null;
	const d = new Date(data);
	const year = d.getFullYear();
	const month = d.getMonth();
	const date = d.getDate();

	return `-${year}-${MONTH_NAMES[month]}-${date}`;
};

export const returnTime = (data) => {
	const d = new Date(data);
	const year = d.getFullYear();
	const month = d.getMonth();
	const date = d.getDate();
	const hour = d.getHours();
	const minute = d.getMinutes();
	const seconds = d.getSeconds();
	return `${MONTH_NAMES[month]} ${date}, ${year}, ${hour}:${minute}:${seconds}`;
};

export const _Fetch = (url, method, data = null) => {
	return new Promise((resolve, reject) => {
		const ID_TOKEN = getCookie('id_token');
		if (ID_TOKEN) {
			axios.defaults.headers.post['Content-Type'] = 'application/json';
			axios.defaults.headers.common['Authorization'] = ID_TOKEN;
		}

		const config = {
			method,
			url,
		};
		if (data) {
			config.data = data;
		}
		axios(config)
			.then((res) => {
				resolve(res);
			})
			.catch((err) => {
				if (err.response === undefined) {
					reject({
						data: {
							message: 'Request Failed',
						},
					});
				}
				if (
					err &&
					err.response &&
					err.response.data &&
					err.response.data.message === 'Invalid token'
				) {
					removeCookie('id_token');
					removeCookie('email');
					setTimeout(() => {
						window.location.reload();
					}, 300);
				}
				reject(err.response);
			});
	});
};

export const FormRequest = (url, data) => {
	return new Promise((resolve, reject) => {
		const ID_TOKEN = getCookie('id_token');
		if (ID_TOKEN) {
			axios.defaults.headers.common['Content-Type'] =
				'application/x-www-form-urlencoded';
			axios.defaults.headers.common['Authorization'] = ID_TOKEN;
		}

		const config = {
			method: 'post',
			url,
		};
		if (data) {
			config.data = data;
		}
		axios(config)
			.then((res) => resolve(res.data))
			.catch((err) => reject(err.response));
	});
};

export const Upload = (url, method, data = null) => {
	return new Promise((resolve, reject) => {
		const ID_TOKEN = getCookie('id_token');
		if (ID_TOKEN) {
			axios.defaults.headers.common['Content-Type'] = 'multipart/form-data';
			axios.defaults.headers.common['Authorization'] = ID_TOKEN;
		}

		const config = {
			method: 'post',
			url,
		};
		if (data) {
			config.data = data;
		}
		axios(config)
			.then((res) => resolve(res.data))
			.catch((err) => reject(err.response));
	});
};

export const readTxtFile = (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = (v) => {
			resolve(reader.result);
		};
		reader.onerror = (e) => {
			reject('error');
		};
		reader.readAsText(file);
	});
};

export const getCookie = (cname) => {
	const name = cname + '=';
	const decodedCookie = decodeURIComponent(document.cookie);
	const ca = decodedCookie.split(';');

	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			setCookie(cname, c.substring(name.length, c.length));
			return c.substring(name.length, c.length);
		}
	}
	return null;
};

export const setCookie = (cname, cvalue) => {
	const d = new Date();
	d.setTime(d.getTime() + 9 * 60 * 60 * 1000);
	const expires = 'expires=' + d.toUTCString();
	document.cookie =
		cname + '=' + encodeURIComponent(cvalue) + ';' + expires + ';path=/';
};

export const removeCookie = (cname) => {
	const d = new Date();
	d.setTime(d.getTime() - 30 * 24 * 60 * 60 * 1000);
	const expires = 'expires=Thu, 01 Jan 1970 00:00:01 GMT;';
	document.cookie = cname + "='';" + expires + ';path=/';
};

export const returnRestDate = (data, isTrial = null) => {
	if (!data) return null;
	const now = new Date();

	const d = new Date(data);
	let last = 1000 * 60 * 60 * 24 * 180 + Math.floor(d);
	if (isTrial) {
		last = 1000 * 60 * 60 * 24 * 16 + Math.floor(d);
	}
	const rest = Math.floor((last - now) / (1000 * 60 * 60 * 24));
	if (rest === 0) {
		return 'D-Day';
	}
	if (rest < 0) {
		return 'Expired';
	}
	return `${rest} Days`;
};

export const returnComma = (num = 0) => {
	if (num.toString().indexOf('.') >= 0) {
		const split = num.toString().split('.');
		const integer = split[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
		return `${integer}.${split[1]}`;
	}
	return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

// NOTE Calculate the Expired Date
// first param => date
// second param => is_trial ? boolean
export const returnExpiredDate = (date, is_trial = true) => {
	if (is_trial) {
		const d = new Date(date);
		const expiredTime = 1000 * 60 * 60 * 24 * 15;
		const month = expiredTime + Math.floor(d);
		return returnDate(month);
	}
};

export const shuffleArray = (array) => {
	let currentIndex = array.length,
		temporaryValue,
		randomIndex;

	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;

		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}

	return array;
};

export const setAnswerList = () => {
	const newArray = [];
	while (newArray.length < 4) {
		setArray(newArray);
	}
	return newArray;
};

const setArray = (array) => {
	const answer = parseInt((Math.random() * 100) / 12) + 1;
	const filters = array.filter((num) => num === answer);
	if (filters.length === 0) {
		array.push(answer);
	}
	return array;
};

export const downloadCSV = (csv, filename) => {
	let csvFile;
	let downloadLink;

	csvFile = new Blob([csv], { type: 'text/csv' });
	downloadLink = document.createElement('a');
	downloadLink.download = filename;
	downloadLink.href = window.URL.createObjectURL(csvFile);
	downloadLink.style.display = 'none';
	document.body.appendChild(downloadLink);
	downloadLink.click();
};

export const downloadJSON = (response) => {
	let jsonFile;
	let downloadLink;

	jsonFile = new Blob([JSON.stringify(response)]);
	downloadLink = document.createElement('a');
	downloadLink.download = `${response.name}.json`;
	downloadLink.href = window.URL.createObjectURL(jsonFile);
	downloadLink.style.display = 'none';
	document.body.appendChild(downloadLink);
	downloadLink.click();
};

export const previewFile = (file) => {
	return new Promise((resolve, reject) => {
		var reader = new FileReader();
		reader.onload = () => {
			resolve(reader.result);
		};
		reader.onerror = (e) => {
			reject(e);
		};
		reader.readAsDataURL(file);
	});
};

export const isValidName = (name) => {
	const pattern = /^[a-zA-Z0-9-_]{3,30}$/;
	return pattern.test(name);
};

export const validEmail = (email) => {
	const pattern = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
	return pattern.test(email);
};

export const showChat = () => {
	const body = document.getElementById('drift-widget-container');
	if (body) {
		body.style.display = 'block';
	}
};

export const hideChat = () => {
	const body = document.getElementById('drift-widget-container');
	if (body) {
		body.style.display = 'none';
	}
};

const convertCountry = (value = {}) => {
	return {
		value: value.alpha2,
		name: value.name,
		label: value.name,
		phoneCode:
			value.countryCallingCodes.length > 0 ? value.countryCallingCodes[0] : '',
		flag: (
			<span
				className={`flag-icon flag-icon-${value.alpha2.toLowerCase()} icon`}
			/>
		)
	};
};

export const getCountry = (info = {}, isFlag = false) => {
	if (info.public && info.public.country !== undefined) {
		const { country } = info.public;
		if (country === '') {
			return <span className="country">Global</span>;
		} else {
			const res = Country.countries.all.filter((item) => {
				if (item.status === 'assigned') {
					return item.alpha2 === country;
				}
				return false;
			})[0];
			let countryData = convertCountry(res);
			if (isFlag) {
				return (
					<span className="country">
						{countryData.flag}
						{countryData.name}
					</span>
				);
			}
			return (
				<span className="country">
					{res.emoji}
					{res.name}
				</span>
			);
		}
	} else {
		return '';
	}
};

export const generateFiles = (exchange) => {
	if (!exchange.is_completed) {
		message.warn(
			'You should finish the exchange setup first, before exporting your settings.'
		);
		return;
	}

	const d = new Date();
	const timestamp = d.getTime();
	const file = { data: [exchange] };

	const a = document.createElement('a');
	const dataStr =
		'data:text/json;charset=utf-8,' +
		encodeURIComponent(JSON.stringify(file));
	a.href = dataStr;
	a.download = `${exchange.name}-${timestamp}.json`;
	a.click();
};

export const getTabParams = () => {
	let paramsString = window.location.search.replace('?', '');
	let activeTab = {};
	if (paramsString.length) {
		let splitValue = paramsString.split('&')
		splitValue.forEach((value) => {
			let temp = value.split('=');
			activeTab[temp[0]] = temp[1];
		});
	}
	return activeTab;
};

export const calculatePrice = (value = 0, price = 1) =>
	math.number(math.multiply(math.fraction(value), math.fraction(price)));

export const calculateBalancePrice = (balance, prices, coins = []) => {
	let accumulated = math.fraction(0);
	coins.forEach((coin) => {
		let { symbol } = coin || {};
		let price = prices[symbol] ? prices[symbol] : 1;
		if (balance.hasOwnProperty(`${symbol}_available`)) {
			accumulated = math.add(
				math.multiply(
					math.fraction(balance[`${symbol}_available`]),
					math.fraction(price)
				),
				accumulated
			);
		}
	});
	return math.number(accumulated);
	// Object.entries(prices).forEach(([key, value]) => {
	// 	if (balance.hasOwnProperty(`${key}_balance`)) {
	// 		accumulated = math.add(
	// 			math.multiply(
	// 				math.fraction(balance[`${key}_balance`]),
	// 				math.fraction(value)
	// 			),
	// 			accumulated
	// 		);
	// 	}
	// });
	// return math.number(accumulated);
};

export const donutFormatPercentage = (value = 0) =>
	numbro(math.number(value / 100)).format(DONUT_PERCENTAGE_FORMAT);

export const calculatePricePercentage = (value = 0, total) => {
	const priceTotal = total ? total : 1;
	return math.number(
		math.multiply(
			math.divide(math.fraction(value), math.fraction(priceTotal)),
			100
		)
	);
};

export const roundNumber = (number = 0, decimals = 4) => {
	if (number === 0) {
		return 0;
	} else if (decimals > 0) {
		const multipliedNumber = math.multiply(
			math.fraction(number),
			math.pow(10, decimals)
		);
		const dividedNumber = math.divide(
			math.floor(multipliedNumber),
			math.pow(10, decimals)
		);
		return math.number(dividedNumber);
	} else {
		return math.floor(number);
	}
};

export const getFormat = (min = 0, fullFormat) => {
	let value = math.format(min, { notation: 'fixed' });
	if (fullFormat) {
		return { digit: 8, format: '0,0.[00000000]' };
	} else if (min % 1) {
		let point = value.toString().split('.')[1]
			? value.toString().split('.')[1]
			: '';
		let res = point
			.split('')
			.map((val) => 0)
			.join('');
		return { digit: point.length, format: `0,0.[${res}]` };
	} else {
		return { digit: 4, format: `0,0.[0000]` };
	}
};

export const formatToCurrency = (amount = 0, min = 0, fullFormat = false) => {
	let formatObj = getFormat(min, fullFormat);
	return numbro(roundNumber(amount, formatObj.digit)).format(formatObj.format);
};

export const DEFAULT_COIN_DATA = {
	fullname: '',
	symbol: '',
	min: 0.001
};

export const checkRequired = (rule, value = "", callback) => {
	if (!value.trim()) {
		callback('This field is required');
	} else {
		callback();
	}
};

export const checkURL = (rule, value, callback) => {
	if (urlRegex.test(value)) {
		callback('Url should not contain http or https protocols');
	} else {
		callback();
	}
};

export const constructURL = (url = '') => {
	if (!url) return url;
	return url.replace(replaceURLRegex, '');
};

export const validAddress = (symbol = '', network) => {
	let currency = symbol.toUpperCase();
	return (rule, address = '', callback) => {
		let valid = true;

		if (network && network !== 'bnb') {
			try {
				valid = WAValidator.validate(address, network);
			} catch (err) {
				valid = false;
			}

		} else {
			switch (currency) {
				case 'BTC':
					valid = WAValidator.validate(address, currency);
					break;
				case 'BCH':
					try {
						bchaddr.toLegacyAddress(address);
						valid = true;
					} catch (err) {
						valid = false;
					}
					break;
				case 'ETH':
					valid = WAValidator.validate(address, currency);
					break;
				case 'XHT':
				case 'BNB':
					valid = WAValidator.validate(address, 'eth');
					break;
				case 'USDT':
					valid = WAValidator.validate(address, 'eth');
					break;
				case 'XRP':
					valid = WAValidator.validate(address, currency);
					break;
				default:
					valid = true;
					break;
			}
		}
		if (!valid) {
			callback(`The ${currency} address is invalid. Please check carefully and input again`);
		} else {
			callback();
		}
	};
};

export const minValue = (minValue) => (rule, value = 0, callback) => {
	if (parseFloat(value) < minValue) {
		callback(`Value must be ${minValue} or higher.`)
	} else {
		callback();
	}
};

export const maxValue = (maxValue) => (rule, value = 0, callback) => {
	if (parseFloat(value) > maxValue) {
		callback(`Value must be ${maxValue} or lower.`)
	} else {
		callback();
	}
};

export const checkUpgrade = (exchange = {}) => {
	if (_toLower(exchange.type) === "diy" ||
		(_toLower(exchange.plan) !== "crypto"
			&& _toLower(exchange.plan) !== "fiat")
	) {
		return true;
	} else {
		return false;
	}
}

export const getNetworkLabelByKey = (network) => {
	if (network) {
		switch (network) {
			case 'eth':
				return 'ERC20';
			case 'trx':
				return 'TRC20';
			case 'bnb':
				return 'BEP20';
			default:
				return network.toUpperCase();
		}
	} else {
		return network;
	}
};
